var React = require('react');

function StarSelected (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M17.4321 18.2986C17.5863 18.9471 16.881 19.4596 16.3119 19.1124L12.0001 16.4826L7.68839 19.1124C7.11924 19.4596 6.41394 18.9471 6.56821 18.2986L7.73694 13.3852L3.90341 10.0971C3.39738 9.66312 3.66677 8.834 4.33128 8.7803L9.36534 8.37351L11.3078 3.71154C11.5642 3.09615 12.436 3.09615 12.6924 3.71154L14.6349 8.37351L19.669 8.7803C20.3335 8.834 20.6029 9.66312 20.0969 10.0971L16.2633 13.3852L17.4321 18.2986Z","fill":"#FFB800"}));
}

StarSelected.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = StarSelected;

StarSelected.default = StarSelected;
